export default __webpack_public_path__ + "static/media/arrowDown.476ea7c2.svg";